import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { PillButton } from '@/components/generals/pill-button'

export const PilotIntro: FC = (): ReactNode => {
    return (
        <section id='meet-pilot' aria-labelledby='meet-pilot-title' className='pb-12 pt-20 md:pb-16 md:pt-28'>
            <div className='fc-container grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-end lg:gap-16'>
                <Reveal className='flex flex-col items-start gap-5'>
                    <p className='text-[14px] font-medium text-violet'>
                        For knowledge workers
                    </p>

                    <h2 id='meet-pilot-title' className='text-[clamp(2.25rem,4.8vw,4.25rem)] font-medium leading-[1.04] tracking-[-0.04em] text-ink'>
                        Meet Pilot, your{' '}
                        <span className='fc-text-gradient'>secret weapon</span>
                        {' '}at work
                    </h2>
                </Reveal>

                <Reveal delay={120} className='flex flex-col items-start gap-7 lg:pb-2'>
                    <p className='text-[17px] leading-relaxed text-slate'>
                        Pilot connects your tools, learns how your work gets done, and takes over the repetitive parts, so more of your day goes to the work that needs you.
                    </p>

                    <PillButton href='#how-it-works' chevron>
                        Explore Pilot
                    </PillButton>
                </Reveal>
            </div>
        </section>
    )
}
